/**
 * Converts a nested object into an array of property paths (ex: 'item.user.name').
 * Handles nested objects but ignores arrays and null values.
 *
 * @param {Object} object - The object to extract paths from.
 * @param {string} [prefix=''] - Optional prefix for nested paths (used internally in recursion).
 * @param {string} [separator=''] - Path separator (ex: '.' | '|')
 * @returns {string[]} Array of property paths.
 */
export default function objectToPaths(object, prefix = '', separator = '.') {
  let paths = [];

  if (object === null || typeof object !== 'object') {
    return paths;
  }

  if (Array.isArray(object)) {
    for (let i = 0; i < object.length; i++) {
      const currentPath = `${prefix}${separator}${i}`;
      if (typeof object[i] === 'object' && object[i] !== null) {
        paths = paths.concat(objectToPaths(object[i], currentPath));
      } else {
        paths.push(currentPath);
      }
    }
    return paths;
  }

  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      const currentPath = prefix ? `${prefix}${separator}${key}` : key;
      if (typeof object[key] === 'object' && object[key] !== null) {
        paths = paths.concat(objectToPaths(object[key], currentPath));
      } else {
        paths.push(currentPath);
      }
    }
  }

  return paths;
}
